import React from 'react';
import { Intent } from 'constants/ui';
import BaseHint from '../BaseHint';
const RequiredFieldsHint = (props) => (React.createElement(BaseHint, { intent: Intent.DANGER, text: "Please fill out all required fields.", textProps: {
        className: 'font-color--red--dark--important',
    }, ...props }));
export default RequiredFieldsHint;
